import { predicateFor } from '@gonfalon/legacy-form-validation/validationUtils';
import { couldBeBoolean } from '@gonfalon/types/couldBeBoolean';
import { couldBeNumber } from '@gonfalon/types/couldBeNumber';
import { isString } from 'lodash';

import { VariationType } from '#utils/flags/flagConstants';
import { couldBeJSONValue } from '#utils/typeUtils';

// `endsWith` check is required to make sure we don't swallow periods while typing, eg '3.' => 3
// eslint-disable-next-line
export const couldBeNumerical = (v: any) => couldBeNumber(v) && !(v.endsWith && v.endsWith('.'));

export const typechecker = {
  [VariationType.NUMBER]: couldBeNumerical,
  [VariationType.BOOLEAN]: couldBeBoolean,
  [VariationType.STRING]: isString,
  [VariationType.JSON]: couldBeJSONValue,
};

export const formatter = {
  [VariationType.NUMBER]: () => 'This must be a number',
  [VariationType.BOOLEAN]: () => 'This must be true or false',
  [VariationType.JSON]: () => 'This must be valid JSON',
  [VariationType.STRING]: () => '',
};

export const matchesType = (t: VariationType) =>
  predicateFor(
    (v) => !typechecker[t](v),
    () => formatter[t](),
  );

export const valueExists = predicateFor(
  (v) => v === null || v === undefined,
  () => 'A value is required',
);
